// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__2f_c7","moreButton":"styles_moreButton__1W22u"};